/**
 * Currency codes recognised by session restore.
 *
 * PROVENANCE: generated from the primary data source's own currency list
 * (https://api.frankfurter.dev/v2/currencies), fetched and verified 2026-08-09.
 * The four precious metals (XAU, XAG, XPT, XPD) are already present in that
 * feed, so no manual additions were needed.
 *
 * SCOPE, AND WHAT IS STILL MISSING: this is 165 codes. The product brief calls
 * for 190+ active ISO 4217 currencies, so the primary source does not by itself
 * satisfy that requirement — closing the gap is a later step, together with the
 * currency metadata module (names, symbols, minor units, peg information).
 *
 * A few entries here are not strictly ISO 4217 — CNH (offshore yuan), GGP, IMP
 * and JEP (Crown dependency pounds), XDR (IMF special drawing rights), and MRO
 * (superseded by MRU). They are kept because the rate feed publishes them, and
 * accepting a code the feed can actually price is the useful behaviour here.
 *
 * This list exists so session restore can reject a stored currency that no
 * longer exists. It is deliberately just codes; it is not the currency metadata
 * module and should not grow into one.
 */

export const KNOWN_CURRENCY_CODES: ReadonlySet<string> = new Set([
  "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN",
  "BAM", "BBD", "BDT", "BHD", "BIF", "BMD", "BND", "BOB", "BRL", "BSD",
  "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHF", "CLP", "CNH", "CNY",
  "COP", "CRC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP",
  "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GGP", "GHS", "GIP",
  "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HTG", "HUF", "IDR", "ILS",
  "IMP", "INR", "IQD", "IRR", "ISK", "JEP", "JMD", "JOD", "JPY", "KES",
  "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP",
  "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT",
  "MOP", "MRO", "MRU", "MUR", "MVR", "MWK", "MXN", "MYR", "MZN", "NAD",
  "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP",
  "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD",
  "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SOS", "SRD", "SSP", "STN",
  "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD",
  "TWD", "TZS", "UAH", "UGX", "USD", "UYU", "UZS", "VES", "VND", "VUV",
  "WST", "XAF", "XAG", "XAU", "XCD", "XCG", "XDR", "XOF", "XPD", "XPF",
  "XPT", "YER", "ZAR", "ZMW", "ZWG",
]);

export function isKnownCurrency(code: unknown): code is string {
  return typeof code === "string" && KNOWN_CURRENCY_CODES.has(code);
}
